import { Box } from "@mui/material";
import { gridPaginationModelSelector, useGridApiContext } from "@mui/x-data-grid";
import Paginator from "components/DataGrid/Paginator";

export const DataGridPagination: React.FC = () => {
  const apiRef = useGridApiContext();
  const paginationModel = gridPaginationModelSelector(apiRef);
  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
        <Paginator 
            currentPage={paginationModel.page + 1}
            totalRecords={apiRef.current.getRowsCount()}
            onPageChange={(page) => {apiRef.current.setPage(page - 1)}}
            pageSize={paginationModel.pageSize}
            onPageSizeChange={apiRef.current.setPageSize}
        />
    </Box>
  );
}